module.exports = __webpack_public_path__ + "static/media/camera.3ea0c3af.png";